import { Navigate, useParams } from "react-router";

export function StoreAdCampaignCodeAndRedirect() {
  const { campaignCode } = useParams();
  // TODO ADD A CAMPAIGN TRACKER
  return <Navigate to="/" />;
}
